import { DataLoaderParams } from '@/types/DataLoaderParams';
import { fetchAllCategoriesLandingPageData } from '@/redux/modules/category';

const discoverCategoriesLoadData = ({ store }: DataLoaderParams) => {
    const { dispatch } = store;

    const promises = [dispatch(fetchAllCategoriesLandingPageData())];

    return Promise.all(promises).then(() => {});
};

export default discoverCategoriesLoadData;
